import { React, useState } from "react";
import BannerBreadcrumb from "../Components/BannerBreadcrumb";

const ReferEarn = () => {
    const [formStep, setFormStep] = useState(1);
    const [isWhatsapp, setIsWhatsapp] = useState("");
    const [altWhatsapp, setAltWhatsapp] = useState("");
    const elegibilityContent = [
        {
            head: "Fill the details for your referral",
            // des: "Apply for multiple loans in one go and discover the one that suits you."
        },
        {
            head: "We will contact that student",
            //  des: "Get expert assistance for quick and hassle-free loans with a higher approval rate."
        },
        {
            head: "If it's converted you will be rewarded",
            // des: "Get the lowest interest rate and expert end-to-end service at no extra cost to you!"
        }
    ]

    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        refName: "",
        refEmail: "",
        refPhone: "",
        type: "Refer & Earn"
    });
    const [fieldErrors, setFieldErrors] = useState({});
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const validate = () => {
        const errors = {};
        if (!/^[a-zA-Z\s]*$/.test(formData.name)) {
            errors.name = "Name should contain only letters and spaces.";
        }
        if (!/^[a-zA-Z\s]*$/.test(formData.refName)) {
            errors.refName = "Name should contain only letters and spaces.";
        }
        if (!/^\d{10}$/.test(formData.phone)) {
            errors.phone = "Phone number must be exactly 10 digits.";
        }
        if (!/^\d{10}$/.test(formData.refPhone)) {
            errors.refPhone = "Phone number must be exactly 10 digits.";
        }
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            errors.email = "Please enter a valid email address.";
        }
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.refEmail)) {
            errors.refEmail = "Please enter a valid email address.";
        }
        return errors;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "phone" || name === "refPhone") {
            if (!/^\d*$/.test(value)) return;
        }
        if (name === "name" || name === "refName") {
            if (!/^[a-zA-Z\s]*$/.test(value)) return;
        }
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
        setFieldErrors((prev) => ({
            ...prev,
            [name]: undefined
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSuccess(false);
        setError(null);

        const errors = validate();
        setFieldErrors(errors);
        if (Object.keys(errors).length > 0) {
            setLoading(false);
            return;
        }

        setLoading(true);
        try {
            const formBody = new URLSearchParams(formData).toString();
            await fetch("https://script.google.com/macros/s/AKfycbytFPsSA7Ob7jAQVmRXGHReCfkcWZmnCvpOLdSL7Zw3kEIvSn5YoQELdQBZOLJccA0/exec", {
                method: "POST",
                body: formBody,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            });
            
            setTimeout(() => {
                setSuccess(true);
                setFormData({
                    name: "",
                    email: "",
                    phone: "",
                    refName: "",
                    refEmail: "",
                    refPhone: "",
                    type: "Refer & Earn"
                });
                setLoading(false);
            }, 1000);
        } catch (err) {
            setError("Failed to submit. Please try again.");
        }
    };
    

    return (
        <>
            <BannerBreadcrumb head={"All you need to know about education loans for studying abroad"} pagename={"Refer & Earn"} />
            <div className="container">
                <div className="row">
                    <div className="col-md-6 loan-eligibility-left">
                        <h5 className="about-head">Refer Friends, Enjoy Exclusive Perks!</h5>
                        <p className="loan-elegibility-des">Refer to your friends and if it’s converted, get upto 3500/- INR reward.<br />Steps to get rewarded:</p>
                        {elegibilityContent.map((item, index) => (
                            <div className="loan-eligibility-content" key={index}>
                                <h5>{item.head}</h5>
                            </div>))}
                    </div>
                    <div className="col-md-6">
                        <form className="loan-check-form" onSubmit={handleSubmit}>
                            <h4 className="">Your Information</h4>
                            {success && <div className="alert alert-success mt-2">Submitted successfully!</div>}
                            {error && <div className="alert alert-danger mt-2">{error}</div>}
                            <div className="row">
                                <div className="col-md-12 finance-head-form">
                                    <label className="form-label finance-label">Name <span>*</span></label>
                                    <input
                                        type="text"
                                        className="form-control finance-input"
                                        placeholder="E.g. Priya Senger"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleChange}
                                        required
                                    />
                                    {fieldErrors.name && (
                                        <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.name}</div>
                                    )}
                                </div>
                                <div className="col-md-12 finance-head-form">
                                    <label className="form-label finance-label">Email <span>*</span></label>
                                    <input
                                        type="email"
                                        className="form-control finance-input"
                                        placeholder="E.g. priya@doe.com"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        required
                                    />
                                    {fieldErrors.email && (
                                        <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.email}</div>
                                    )}
                                </div>
                                <div className="col-md-12 finance-head-form">
                                    <label className="form-label finance-label">Phone<span>*</span></label>
                                    <input
                                        type="tel"
                                        className="form-control finance-input"
                                        placeholder="E.g. 8888880000"
                                        name="phone"
                                        value={formData.phone}
                                        onChange={handleChange}
                                        required
                                        maxLength={10}
                                    />
                                    {fieldErrors.phone && (
                                        <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.phone}</div>
                                    )}
                                </div>
                            </div>
                            <h4 className="mt-3">Referral's Information</h4>
                            <div className="row">
                                <div className="col-md-12 finance-head-form">
                                    <label className="form-label finance-label">Name <span>*</span></label>
                                    <input
                                        type="text"
                                        className="form-control finance-input"
                                        placeholder="E.g. Priya Senger"
                                        name="refName"
                                        value={formData.refName}
                                        onChange={handleChange}
                                        required
                                    />
                                    {fieldErrors.refName && (
                                        <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.refName}</div>
                                    )}
                                </div>
                                <div className="col-md-12 finance-head-form">
                                    <label className="form-label finance-label">Email <span>*</span></label>
                                    <input
                                        type="email"
                                        className="form-control finance-input"
                                        placeholder="E.g. priya@doe.com"
                                        name="refEmail"
                                        value={formData.refEmail}
                                        onChange={handleChange}
                                        required
                                    />
                                    {fieldErrors.refEmail && (
                                        <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.refEmail}</div>
                                    )}
                                </div>
                                <div className="col-md-12 finance-head-form">
                                    <label className="form-label finance-label">Phone<span>*</span></label>
                                    <input
                                        type="tel"
                                        className="form-control finance-input"
                                        placeholder="E.g. 8888880000"
                                        name="refPhone"
                                        value={formData.refPhone}
                                        onChange={handleChange}
                                        required
                                        maxLength={10}
                                    />
                                    {fieldErrors.refPhone && (
                                        <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.refPhone}</div>
                                    )}
                                </div>
                                <div className="col-12">
                                    <button type="submit" className="loan-btn w-100 mt-3" disabled={loading}>
                                        {loading ? "Submitting..." : "Submit"}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ReferEarn;
